package ir.hosen.resume.util

enum class ExperienceMock(
    val number: String,
    val role: String,
    val company: String,
    val date: String,
) {

    BITALONE(
        number = "01",
        role = "Android Developer Intern",
        company = "Bitalone",
        date = "Jun 19 - Oct 20"
    ),
    DONE(
        number = "02",
        role = "Android Developer",
        company = "Done",
        date = "Oct 20 - Oct 25"
    ),
    GEM(
        number = "03",
        role = "Android Developer",
        company = "Gem",
        date = "Feb 22 - Present"
    ),

}

object SkillIcons {

    interface Icon {
        val title: String
        val src: String
    }

    enum class GroupOne(
        override val title: String,
        override val src: String,
    ) : Icon {
        KOTLIN(title = "Kotlin", src = "/kotlin.svg"),
        ANDROID(title = "Android", src = "/android.svg"),
        FIGMA(title = "Figma", src = "/figma.svg"),
        FIREBASE(title = "Firebase", src = "/firebase.svg"),
        GIT(title = "Git", src = "/git.svg"),
        INTELLI_J(title = "IntelliJ", src = "/intelli_j.svg"),
        JAVA(title = "Java", src = "/java.svg"),
        POSTMAN(title = "Postman", src = "/postman.svg"),
    }

    enum class GroupTwo(
        override val title: String,
        override val src: String,
    ) : Icon {
        ANDROID_STUDIO(title = "Android Studio", src = "/android_studio.svg"),
        API(title = "REST API", src = "/api.svg"),
        APPLE(title = "IOS", src = "/apple.svg"),
        COMPOSE(title = "Compose", src = "/compose.svg"),
        GRADLE(title = "Gradle", src = "/gradle.svg"),
        KMP(title = "Kotlin Multi Platform", src = "/kmp.svg"),
        SQL_LITE(title = "SQL Lite", src = "/sql_lite.svg"),
        GOOGLE_PLAY(title = "Google Play", src = "/google_play.svg"),
    }
}